import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './_helpers';
import { App } from './components';
import { ErrorBoundary } from './components/_shared/ErrorBoundary';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// setup fake backend
import { configureFakeBackend } from './_helpers';
import { AppWrapper } from './AppWrapper';
//configureFakeBackend();

// Mount ToastContainer on its own root element BEFORE the main app.
// This replaces the v5 toast.configure() behavior — ensures the container
// is available immediately so toast() calls during early lifecycle
// (e.g. componentDidMount triggering a 401 → toast) are not lost.
const toastDiv = document.createElement('div');
toastDiv.id = 'toast-root';
document.body.appendChild(toastDiv);
const toastRoot = createRoot(toastDiv);
toastRoot.render(
    <ToastContainer
        position="bottom-right"
        autoClose={2500}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
        closeButton={false}
        transition={Slide}
    />,
);

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <ErrorBoundary>
            <AppWrapper>
                <App />
            </AppWrapper>
        </ErrorBoundary>
    </Provider>,
);
